import { z } from 'zod';

export const authSchema = z.object({
  username: z.string().min(1, 'Login majburiy'),
  password: z
    .string()
    .min(3, "Parol kamida 6 ta belgidan iborat bo'lishi kerak"),
});

export type AuthFormData = z.infer<typeof authSchema>;
